import type { Immutable } from "@/types/immutable";

export function predictionsToPercentagePoints({
  home,
  draw,
  away,
}: Immutable<Record<"home" | "draw" | "away", number>>): Immutable<
  Record<"home" | "draw" | "away", number>
> {
  const total = home + draw + away;

  if (total === 0) {
    return { home: 0, draw: 0, away: 0 };
  }

  const drawPercentagePoints = Math.floor((100 * draw) / total);
  const awayPercentagePoints = Math.round((100 * away) / total);
  const homePercentagePoints =
    100 - drawPercentagePoints - awayPercentagePoints;

  return {
    home: homePercentagePoints,
    draw: drawPercentagePoints,
    away: awayPercentagePoints,
  } as const;
}
